import React from 'react';
import { connect } from 'react-redux';
import { RootReducerState } from 'redux/reducers';
import { ViewMounter } from '../../view_mounter';
import { SecureRoute } from '../../shared/secure_route';
import { Panel, PanelPresets, UserPermissionsIds } from '../../../utility/enumerations';
import MqaCheck from './mqa_check';

function MQACheckContainerScreen() {
  return (
    <div>
      <SecureRoute
        path="/physician/mqa-check"
        pathPermissionId={UserPermissionsIds.AccessApiToolsMqa}
        render={(props) => ViewMounter(props, {
          viewPath: 'physician/mqa/mqa_check.tsx',
          targetPanel: Panel.Primary,
          panelLayout: PanelPresets.OneFull,
          clear: true,
          viewProps: undefined,
          overrideLocation: undefined,
          focusView: undefined,
          params: undefined
        })}
        allowAnonymous={undefined}
        component={MqaCheck}
      />
    </div>
  );
}

function mapStateToProps(state: RootReducerState) {
  return {
    userTypeId: state.security.user.userTypeId,
  };
}

const mapDispatchToProps = {
};

export default connect(mapStateToProps, mapDispatchToProps)(MQACheckContainerScreen);
